// BAC CUSTOM CODE
(function () {
   const cart                    = JSON.parse(document.getElementById('cartObj').innerHTML),
         cartItems               = cart.items,
         cartForm                = document.querySelector('form.cart'),
         checkoutBtn             = document.querySelector('button[name="checkout"]'),
         nagPopUp                = document.querySelector('.nag-pop-up'),
         nagPopUpWindow          = document.querySelector('.nag-pop-up__window'),
         nagPopUpLoader          = document.querySelector('.nag-pop-up__loader'),
         nagPopUpBtnConfirm      = document.querySelector('.nag-pop-up__btn--confirm'),
         nagPopUpBtnCancel       = document.querySelector('.nag-pop-up__btn--cancel'),
         nagPopUpDonationSpans   = document.querySelectorAll('.nag-pop-up__donation-amt');
   let   isNagActive             = false;
   let   donationBtns           = document.querySelectorAll('.donation__item input');

   // Show donation nag pop up when submit event on cart form occurs. (isNagActive is used for when customer continues after Nag which fires another form submit event)
   cartForm.addEventListener('submit', (event) => {
      if (event.submitter != checkoutBtn || isNagActive) {
         return;
      }
     
      isNagActive = true;
      donationNag(event);
   });

   // When customer chooses to add donation nag, add the donation product, then proceed to checkout
   nagPopUpBtnConfirm.addEventListener('click', async (event) => {
      await addDonationToCart(event);
      await checkoutBtn.click();
      await togglePopup(nagPopUpWindow);
      await togglePopup(nagPopUpLoader);
   });

   // When customer refuses donation nag, proceed to checkout
   nagPopUpBtnCancel.addEventListener('click', () => {
      checkoutBtn.click();
      togglePopup(nagPopUpWindow);
      togglePopup(nagPopUpLoader);
   });


   // Popup that requests ('nags') for an additional donation if one is not already present in customer's cart
   // ==================================
   function donationNag(event) {
      if ( !checkForDonation(cartItems) && !checkForDonSelection(donationBtns) ) {
          const cartSubtotal = cart.total_price;
          const donNagProduct = JSON.parse(document.getElementById('allProductsObj').innerHTML);

          event.preventDefault();
          const donationAmt = calcNagAmt(cartSubtotal);

          for (span of nagPopUpDonationSpans) {
              span.innerText = donationAmt;
          }

          const variantId = getDonationVariant(donNagProduct.variants, donationAmt);

          nagPopUpBtnConfirm.id = `${variantId}`;

          togglePopup(nagPopUp);
          return;
      }
   }

   // Auto adds donation product to cart
   // ==================================
   async function addDonationToCart(event) {
      let formData = {
          'items': [{
           'id': event.target.id,
           'quantity': 1
           }]
         };

      await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .catch((error) => {
          console.error('Error:', error);
      });
   }

   // Determines if a donation product currently exists in the cart
   function checkForDonation(items) {
      return items.filter(item => item.product_title.includes('Donation')).length;
   }

   // Determines if donation has been selected (but, not in cart yet)
   function checkForDonSelection(nodeList) {
    const items = [...nodeList];
      return items.filter(item => item.checked).length;
   }

   // Dynamically determines which donation to display based on the customer's subtotal. Shopify provides totals without decimals (price x 100)
   function calcNagAmt(subtotal) {
      if (subtotal > 10000) {
         return '$20';
      }
      if (subtotal > 5000) {
         return '$10';
      }
      if (subtotal > 1000) {
         return '$5';
      } 
      return '$3';
   }

   function getDonationVariant(variants, amt) {
      if (variants) {
         for (let variant of variants) {
            if (variant.option1 === amt) {
                  return variant.id;
            }
         }
      }
   }

   function togglePopup(popUpElement) {
      popUpElement.classList.toggle('hide');
   }

})();